import React, { useEffect, useState, useCallback } from "react";
import ProgressBar from "./ProgressBar";
import errorWrapper from "./ErrorWrapper";

function BaseComponent(props) {
  const { goalRef, opts }  = props;
  const { goalDataSubscribe, onComplete, onInView, handleOnRender } = opts;
  const [goalData, setGoalData] = useState(null);
  const [status, setStatus] = useState(null);
  const [showHeart, setShowHeart] = useState(false);

  useEffect(() => {
    setStatus("loading");
    const unsubscribe = goalDataSubscribe((error, data) => {
      if (data) {
        setGoalData(data);
        setStatus("success");
      }
    });

    const unSubOnComplete = onComplete(() => {
      setShowHeart(true);
    });

    return () => {
      unsubscribe();
      unSubOnComplete();
    };
  }, [goalRef]);

 if (status === "error") {
    return null;
  } else if (goalData) {
    return (
      <div className="App">
        <ProgressBar 
          data={goalData} 
          handleOnRender={handleOnRender}
          animationProps={{
            showHeart,
            onInView,
            setShowHeart
          }}
        />
      </div>
    );
  } else {
    // Is Loading or something else
    return null;
  }
}

export default errorWrapper(BaseComponent);
